import type { Maybe } from "@regle/core"
import { withMessage } from "@regle/rules"

function validatePhoneNumber(value: Maybe<string>) {
  if (!value) return true
  const phoneNumberPattern =
    /(^\+[0-9]{2}|^\+[0-9]{2}\(0\)|^\(\+[0-9]{2}\)\(0\)|^00[0-9]{2}|^0)([0-9]{9}$|[0-9\-\s]{10}$)/
  return phoneNumberPattern.test(value)
}

function validateEmail(value: Maybe<string>) {
  if (!value) return true
  // https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address
  const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z]{2,})+$/
  return emailPattern.test(value)
}

function validateMultipleEmails(value: Maybe<string>) {
  if (!value) return true
  const emailList = value.split(";").filter((email) => email.trim() !== "")
  return emailList.every((email) => validateEmail(email.trim()))
}

function required(value: unknown) {
  return value !== undefined && value !== null && value !== ""
}

function validateCitizenNumber(value: Maybe<string>) {
  if (!value) return true

  // A BSN must be exactly 9 digits and contain only numbers.
  if (!/^[0-9]{9}$/.test(value)) return false

  // "Elfproef" (11-test): 9*d1 + 8*d2 + ... + 2*d8 - 1*d9 must be divisible by 11.
  const digits = value.split("").map(Number)
  const sum = digits.reduce((acc, digit, index) => {
    const weight = index === 8 ? -1 : 9 - index
    return acc + digit * weight
  }, 0)

  return sum % 11 === 0
}

export const phoneNumberValidator = withMessage(validatePhoneNumber, "Telefoonnummer is ongeldig")

export const emailValidator = withMessage(validateEmail, "Email is ongeldig")

export const multipleEmailsValidator = withMessage(
  validateMultipleEmails,
  "Één of meer emailadressen zijn ongeldig"
)

export const requiredValidator = withMessage(required, "Dit veld is vereist")

export const citizenNumberValidator = withMessage(
  validateCitizenNumber,
  "Burgerservicenummer is ongeldig"
)
